export default function DSA_Selection_Sort() {
  return <div>DSA_Selection_Sort Component</div>;
}
